export enum ApplicantType {
  Primary = "P",
  Secondary = "S"
}
